import styled from 'styled-components'

import BootstrapModalTitle from 'react-bootstrap/lib/ModalTitle'

export const ModalTitle = styled(BootstrapModalTitle)`
  font-size: ${props => props.theme.fontSizes.modal.modalTitle};
  text-align: center;
  color: ${props => props.theme.colors.ebonyClay};
  opacity: 0.87;
  line-height: 40px;
  pointer-events: none;
`
